<template>
	<v-layout row wrap>
		<div class="flex xl12 lg12 md12 mx-auto">
			<vue-pull-refresh :on-refresh="onRefresh" :config="pullConfig">
				<v-card style="width: 100%" color="transparent" elevation="0">
					<v-card-title class="px-1 pt-0">
						<v-flex class="hidden-sm-and-down"><h1>Reserveringen</h1></v-flex>
						<v-tabs v-model="filter" fixed-tabs color="transparent">
							<v-tab :key="'all'" :href="'#all'" ripple>Alle</v-tab>
							<v-tab :key="'today'" :href="'#today'" ripple>Vandaag</v-tab>
							<v-tabs-slider color="blue darken-2"></v-tabs-slider>
						</v-tabs>
						<v-spacer></v-spacer>
						<v-text-field
							prepend-inner-icon="search"
							color="blue darken-2"
							label="Zoeken"
							single-line
							hide-details
							v-model="searchText"
						></v-text-field>
					</v-card-title>

					<v-data-table
						v-model="selected"
						v-bind:headers="headers"
						v-bind:items="items"
						select-all
						v-bind:pagination.sync="pagination"
						:rows-per-page-items="[25, 50]"
						:rows-per-page-text="'Resultaten per pagina'"
						:loading="loading"
						no-data-text="..."
						item-key="name"
					>
						<v-progress-linear
							slot="progress"
							color="blue"
							indeterminate
						></v-progress-linear>
						<template slot="headers" slot-scope="props">
							<tr class="hidden-sm-and-down">
								<th
									v-for="header in props.headers"
									:key="header.text"
									:class="[
										'text-xs-left column sortable',
										pagination.descending ? 'desc' : 'asc',
										header.value === pagination.sortBy ? 'active' : ''
									]"
									@click="changeSort(header.value)"
								>
									{{ header.text }}
									<v-icon>arrow_upward</v-icon>
								</th>
							</tr>
						</template>

						<template slot="items" slot-scope="props">
							<tr :active="props.selected">
								<td
									class="hidden-sm-and-down text-xs-left"
									:class="lastUpdated === props.item.id ? 'updated' : ''"
									@click.stop.prevent="showReservation(props.item)"
								>
									{{ props.item.reservationNumber }}
								</td>
								<td
									class="text-xs-left hidden-xs-only description"
									@click.stop.prevent="showReservation(props.item)"
								>
									{{
										props.item.rentDescription
											? props.item.rentDescription
											: props.item.car
									}}
									<small class="d-block" v-if="props.item.amountPaid"
										>Betaald: &euro; {{ props.item.amountPaid }}</small
									>
								</td>
								<td
									class="text-xs-left hidden-xs-only"
									style="position: relative"
								>
									<span
										@click.stop.prevent="showReservation(props.item)"
										class="d-inline-block"
										>{{ props.item.unitDescription }}
										<br />
										<small
											>Kenteken: {{ props.item.license }} Pincode:
											{{ props.item.fuelCardPin }}</small
										>
									</span>
									<unit-control
										v-if="props.item.isControllable === '1'"
										:unitId="props.item.unitId"
										class="unit-control"
										:class="props.item.active == '1' ? 'active' : 'inActive'"
									></unit-control>
								</td>

								<td
									class="text-xs-left hidden-xs-only clickable"
									@click.stop.prevent="showUser(props.item.user_id)"
								>
									{{ props.item.firstname }} {{ props.item.lastname }}
									<span v-if="props.item.companyname">
										- {{ props.item.companyname }}</span
									>{{ getTempCustomer(props.item) }}
									<br />
									<small>{{ props.item.phoneno }}</small>
								</td>
								<td
									class="text-xs-left hidden-xs-only"
									@click.stop.prevent="showReservation(props.item)"
								>
									{{ utils.getFormattedDate(props.item.startDate, true) }}
									<br />
									<small>{{
										utils.getDayDescription(props.item.startDate, true)
									}}</small>
								</td>
								<td
									class="text-xs-left hidden-xs-only"
									@click.stop.prevent="showReservation(props.item)"
								>
									{{ utils.getFormattedDate(props.item.endDate, true) }}
									<br />
									<small>{{
										utils.getDayDescription(props.item.endDate, true)
									}}</small>
								</td>
								<td
									class="text-xs-left hidden-xs-only"
									@click.stop.prevent="showReservation(props.item)"
									@mouseenter="
										props.item.pullInfo = true;
										getInfo(props.item);
									"
									@mouseleave="props.item.pullInfo = false"
									style="position: relative"
								>
									<v-tooltip bottom>
										<span
											class="active reservationStatus"
											slot="activator"
											v-if="props.item.active == '1'"
											>ACTIEF
											<status-indicator
												:positive="
													!unitPositions[props.item.wialonUnitId] ||
														(unitPositions[props.item.wialonUnitId] &&
															unitPositions[props.item.wialonUnitId].sc > 0)
												"
												:intermediary="
													unitPositions[props.item.wialonUnitId] &&
														unitPositions[props.item.wialonUnitId].sc <= 3
												"
												:negative="
													unitPositions[props.item.wialonUnitId] &&
														unitPositions[props.item.wialonUnitId].sc === 0
												"
												pulse
												v-if="props.item.active == '1'"
											></status-indicator>
											<b :class="`d-block unit_${props.item.wialonUnitId}`"></b>
										</span>
										<span v-html="props.item.info"></span>
										<span
											class="today reservationStatus"
											slot="activator"
											v-if="
												props.item.active != '1' &&
													utils.getDayDescription(
														props.item.startDate,
														true
													) === 'Vandaag'
											"
											>{{ getTimeBetween(props.item.startDate, 'hours') }}</span
										>
										<span
											class="other reservationStatus"
											slot="activator"
											v-if="
												props.item.active != '1' &&
													utils.getDayDescription(
														props.item.startDate,
														true
													) !== 'Vandaag'
											"
											>{{ getTimeBetween(props.item.startDate, 'days') }}</span
										>
									</v-tooltip>
								</td>
								<!-- Mobile -->
								<td
									class="text-xs-left hidden-sm-and-up itemRow"
									style="position: relative"
								>
									<h3 @click.stop.prevent="showReservation(props.item)">
										{{ props.item.firstname }} {{ props.item.lastname }}
										<span v-if="props.item.companyname">
											- {{ props.item.companyname }}</span
										>{{ getTempCustomer(props.item) }}
										<small
											v-if="lastUpdated === props.item.id"
											style="color: #1565c0"
											>(OPGESLAGEN)</small
										>
									</h3>
									<span
										@click.stop.prevent="showReservation(props.item)"
										class="itemContainer"
									>
										#{{ props.item.reservationNumber }}
										{{ props.item.rentDescription }}
										<br />
										{{ props.item.car }}

										<br />
										{{ utils.getFormattedDate(props.item.startDate, true) }} ({{
											utils.getDayDescription(props.item.startDate, true)
										}})
										<br />
										{{ utils.getFormattedDate(props.item.endDate, true) }} ({{
											utils.getDayDescription(props.item.endDate, true)
										}})
										<br />
										Pincode: {{ props.item.fuelCardPin }}
										<span
											class="active reservationStatus"
											v-if="props.item.active == '1'"
										>
											<status-indicator
												:positive="
													!unitPositions[props.item.wialonUnitId] ||
														(unitPositions[props.item.wialonUnitId] &&
															unitPositions[props.item.wialonUnitId].sc > 0)
												"
												:intermediary="
													unitPositions[props.item.wialonUnitId] &&
														unitPositions[props.item.wialonUnitId].sc <= 3
												"
												:negative="
													unitPositions[props.item.wialonUnitId] &&
														unitPositions[props.item.wialonUnitId].sc === 0
												"
												pulse
												v-if="props.item.active == '1'"
												style="transform: translate(35%,0);"
												class="right"
											></status-indicator
											>ACTIEF
											<b :class="`d-block unit_${props.item.wialonUnitId}`"></b>
										</span>
										<span
											class="today reservationStatus"
											v-if="
												props.item.active != '1' &&
													utils.getDayDescription(
														props.item.startDate,
														true
													) === 'Vandaag'
											"
											>{{ getTimeBetween(props.item.startDate, 'hours') }}</span
										>
										<span
											class="other reservationStatus"
											v-if="
												props.item.active != '1' &&
													utils.getDayDescription(
														props.item.startDate,
														true
													) !== 'Vandaag'
											"
											>{{ getTimeBetween(props.item.startDate, 'days') }}</span
										>
									</span>

									<unit-control
										v-if="props.item.isControllable === '1'"
										:unitId="props.item.unitId"
										:class="props.item.active == '1' ? 'active' : 'inActive'"
										class="unit-control"
									></unit-control>
									<!--<device-battery class="right" style="transform: translate(100%,-5px);"></device-battery>-->
									<!-- <status-indicator positive pulse v-if="props.item.active == '1'" style="transform: translate(35%,0);" class="right"></status-indicator> -->
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-card>
			</vue-pull-refresh>
		</div>
	</v-layout>
</template>


<script>
import * as utils from '@/utils/utils';
import moment from 'moment';
import TableLoader from '@/components/TableLoader';
import DeviceBattery from '@/components/Units/DeviceBattery';
import UnitControl from '@/components/Units/UnitControl';
import VuePullRefresh from 'vue-pull-refresh';
import { StatusIndicator } from 'vue-status-indicator';
import { _ } from 'vue-underscore';
import { fuse } from 'fuse.js';
export default {
	name: 'ReservationsTable',
	components: {
		TableLoader,
		VuePullRefresh,
		StatusIndicator,
		DeviceBattery,
		UnitControl
	},
	data() {
		return {
			dialog: false,
			loading: false,
			utils: utils,
			pagination: {
				sortBy: 'startDate',
				descending: false
			},
			selected: [],
			searchText: '',
			pullConfig: window.pullConfig,
			headers: [
				{
					text: '#',
					align: 'left',
					value: 'id'
				},
				{
					text: 'Omschrijving',
					value: 'fullname',
					class: 'hidden-xs-only'
				},
				{
					text: 'Auto',
					value: 'car',
					class: 'hidden-xs-only'
				},
				{
					text: 'Naam',
					value: 'rentDescription',
					class: 'hidden-xs-only description'
				},
				{
					text: 'Startdatum',
					value: 'startDate',
					class: 'hidden-xs-only'
				},
				{
					text: 'Einddatum',
					value: 'endDate',
					class: 'hidden-xs-only'
				},
				{
					text: 'Status',
					value: 'active',
					class: ''
				}
			],
			items: [],
			allItems: [],
			todayItems: [],
			fuse: fuse,
			lastUpdated: '',
			filter: 'all',
			unitPositions: {}
		};
	},
	watch: {
		filter(newVal) {
			this.getReservations(true, false);
		},
		$route(to, from) {
			if (to.name === 'Reservations') {
				this.getReservations(true, true);
			}
		},
		searchText(val) {
			this.searchData(val);
		}
	},
	created: function() {
		var self = this;
		this.getReservations(true, false);
		window.emitter.$on('updateReservations', function(data) {
			if (self.$route.name === 'Reservations' || self.$route.name === 'Home') {
				self.getReservations(true, true).then(response => {
					if (data && data.id) {
						self.lastUpdated = data.id;
					}
				});
			}
			``;
		});

		window.emitter.$on('newEvents', data => {
			self.updateUnitPositions(data);
		});
	},
	beforeDestroy() {
		window.emitter.$off('updateReservations');
		window.emitter.$off('newEvents');
	},
	methods: {
		searchData(val) {
			let self = this;
			let searchText = val.toLowerCase();
			let searchableItems =
				this.filter === 'all' ? this.allItems : this.todayItems;
			var options = {
				shouldSort: true,
				findAllMatches: true,
				threshold: 0.1,
				location: 0,
				distance: 200,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: [
					'rentDescription',
					'firstname',
					'lastname',
					'car',
					'id',
					'companyname'
				]
			};
			if (val == '') {
				this.items = searchableItems;
			} else {
				this.$search(searchText, searchableItems, options).then(results => {
					self.items = results;
				});
			}
		},
		getReservations(showLoading, refresh) {
			var self = this;
			this.loading = showLoading;

			var promise = new Promise(function(resolve, reject) {
				if (self.allItems.length && !refresh) {
					resolve();
				} else {
					utils.getData(basePath + 'api/reservations/').then(function(json) {
						self.allItems = json.data;
						resolve();

						// Run search query after refresh
						self.searchData(self.searchText);
					});
				}
			});

			promise.then(function() {
				if (self.filter === 'all') {
					self.items = self.allItems;
				} else {
					if (!self.todayItems.length) {
						self.todayItems = _.filter(self.allItems, {
							isToday: '1'
						});
					}
					self.items = self.todayItems;
				}
				self.loading = false;
				self.$emit('dataLoaded');
			});

			return promise;
		},
		showReservation(reservation, e) {
			reservation.edit = true;
			//console.log(reservation)
			this.$emit('showReservation', {
				id: reservation.id
			});

			return false;
		},
		toggleAll() {
			if (this.selected.length) this.selected = [];
			else this.selected = this.items.slice();
		},
		changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		showUnit(unitId) {
			this.$emit('showUnit', {
				id: unitId
			});
		},
		showUser(userId) {
			this.$emit('showUser', userId);
		},
		onRefresh() {
			const self = this;
			return new Promise(function(resolve, reject) {
				self.getReservations(false, true).then(function() {
					setTimeout(function() {
						resolve();
					}, 100);
				});
			});
		},
		getTempCustomer(reservation) {
			return reservation.tempCustomerName
				? ' (' + reservation.tempCustomerName + ')'
				: '';
		},
		getTimeBetween(startDate, timeScale) {
			var now = moment(new Date());
			var duration = moment.duration(now.diff(startDate));
			if (timeScale === 'hours') {
				var hours = String(Math.abs(duration.asHours()).toFixed(2));
				if (hours) {
					var hoursData = hours.split('.');
					return (
						hoursData[0] +
						'u' +
						' ' +
						String(parseInt((parseFloat(hoursData[1]) / 100) * 60)) +
						'min'
					);
				} else {
					return '';
				}
			} else {
				let days = Math.ceil(Math.abs(duration.asHours() / 24));
				return days <= 1 ? 'morgen' : days + ' dagen';
			}
		},
		getInfo(item) {
			let self = this;
			if (!item.info) {
				item.info = 'Info ophalen...';
			}
			setTimeout(function() {
				if (!item.pullInfo) return false;
				// Get cost and position
				utils
					.getData(basePath + 'api/reservations/reservationCost/' + item.id)
					.then(function(response) {
						item.info = `&euro;${response.data.cost.total} 	<br/> ${
							response.data.mileage
						} Km`;

						if (self.unitPositions[item.wialonUnitId]) {
							item.info += `<br/>Satellieten: ${
								self.unitPositions[item.wialonUnitId].sc
							}`;
						}

						if (
							response.data.cost.status &&
							response.data.cost.status.percentage
						) {
							'<br/>Batterij: ' + response.data.cost.status.percentage + '%';
						}
					});
			}, 500);
		},
		updateUnitPositions(updatedUnits) {
			var self = this;

			for (var i = 0; i < updatedUnits.length; i++) {
				var unit = updatedUnits[i];
				if (unit.d.pos) {
					self.unitPositions[unit.i] = unit.d.pos;
				}
			}
		}
	}
};
</script>
<style lang="scss">
.unit-control {
	position: absolute;
	right: 5px;
	top: 10px;
	&.inActive {
		opacity: 0.5;
	}
}
.itemContainer {
	width: 100%;
	display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Reservations/ReservationsTable.vue